import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.number.constructor";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { validatenull as _validatenull } from "@/util/validate";
import config from "./config.js";
export default {
  name: "sidebarItem",
  data: function data() {
    return {
      config: config
    };
  },
  props: {
    menu: {
      type: Array
    },
    screen: {
      type: Number
    },
    first: {
      type: Boolean,
      default: false
    },
    props: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    collapse: {
      type: Boolean
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  computed: _objectSpread(_objectSpread({}, mapGetters(["roles"])), {}, {
    labelKey: function labelKey() {
      return this.props.label || this.config.propsDefault.label;
    },
    pathKey: function pathKey() {
      return this.props.path || this.config.propsDefault.path;
    },
    iconKey: function iconKey() {
      return this.props.icon || this.config.propsDefault.icon;
    },
    childrenKey: function childrenKey() {
      return this.props.children || this.config.propsDefault.children;
    },
    nowTagValue: function nowTagValue() {
      return this.$router.$avueRouter.getValue(this.$route);
    }
  }),
  methods: {
    vaildAvtive: function vaildAvtive(item) {
      var _this = this;
      var groupFlag = (item["group"] || []).some(function (ele) {
        return _this.$route.path.includes(ele);
      });
      return this.nowTagValue === item[this.pathKey] || groupFlag;
    },
    vaildRoles: function vaildRoles(item) {
      item.meta = item.meta || {};
      return item.meta.roles ? item.meta.roles.includes(this.roles) : true;
    },
    validatenull: function validatenull(val) {
      return _validatenull(val);
    },
    open: function open(item) {
      if (this.screen <= 1) this.$store.commit("SET_COLLAPSE");
      this.$router.$avueRouter.group = item.group;
      this.$router.push({
        path: this.$router.$avueRouter.getPath({
          name: item[this.labelKey],
          src: item[this.pathKey]
        }),
        query: item.query
      });
    }
  }
};